import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  batch, shallowEqual, useDispatch, useSelector
} from 'react-redux';

import { toggleRelatedArticleListingModal } from '../../../actions/application/application';
import Modal from '../../../components/Modal/Modal';
import TableHead from '../../../components/Table/TableHead';
import TableRow from '../../../components/Table/TableRow';
import TableHeadData from '../../../components/Table/TableHeadData';
import Checkbox from '../../../components/Checkbox/Checkbox';
import TableBody from '../../../components/Table/TableBody';
import Table from '../../../components/Table/Table';
import getListings from '../../../thunks/listings/getListings';
import TableData from '../../../components/Table/TableData';
import Badge from '../../../components/Badge/Badge';
import ButtonTypes from '../../../constants/buttonTypes';
import ArticlesRelatedListingItem from './ArticlesRelatedListingItem';
import toggleArrayItem from '../../../helpers/toggleArrayItem';
import { MAX_RELATED_ARTICLES_LISTING } from '../../../constants/general';
import DataLoader from '../../../components/DataLoader/DataLoader';
import Button from '../../../components/Button/Button';
import { IconArrowDown } from '../../../assets/icon';
import { setListingsFilter } from '../../../actions/listings/listingsFilter';

const containerClassName = 'pt-0';
const tableContainerClassName = 'h-[500px] overflow-auto';
const allCheckBoxClassName = 'pl-0';

const ArticlesRelatedListingsModal = ({ selectedListing, setFieldValue }) => {
  const [selectedId, setSelectedId] = useState((selectedListing || [])?.map(({ listing_id: id }) => id));
  const dispatch = useDispatch();
  const tableHeader = [
    'info', 'status', 'brand'
  ];
  const {
    relatedArticleListingModal, listingsData, listingsLoading, currentPage, lastPage
  } = useSelector((state) => ({
    relatedArticleListingModal: state?.application.relatedArticleListingModal,
    listingsData: state?.getListings.data,
    listingsLoading: state?.getListings.loading,
    currentPage: state?.getListings.currentPage,
    lastPage: state?.getListings.lastPage,
  }), shallowEqual);

  useEffect(() => {
    if (relatedArticleListingModal) {
      dispatch(getListings());
    }
  }, [relatedArticleListingModal]);

  const onSelect = (id) => setSelectedId(toggleArrayItem(selectedId, id));
  const onSave = () => {
    setFieldValue('relatedItem', listingsData?.filter(({ listing_id: id }) => selectedId?.includes(id)));
    dispatch(toggleRelatedArticleListingModal());
  };

  const onLoadMode = () => {
    batch(() => {
      dispatch(setListingsFilter({
        page: currentPage + 1
      }));
      dispatch(getListings(false));
    });
  };

  return (
    <Modal
      visible={relatedArticleListingModal}
      toggleVisible={() => dispatch(toggleRelatedArticleListingModal())}
      title="Related listing"
      saveText={`Select (${selectedId.length})`}
      hideCloseBtn
      onSave={onSave}
      canSave={!selectedId?.length || selectedId?.length >= MAX_RELATED_ARTICLES_LISTING + 1}
    >
      <div className={containerClassName}>
        {!listingsLoading && !listingsData?.length && <div>no data</div>}
        {listingsLoading && !listingsData?.length && <DataLoader />}
        {!!listingsData?.length
        && (
          <div className={`${tableContainerClassName} customScroll`}>
            <Table>
              <TableHead>
                <TableRow bordered>
                  <TableHeadData className={allCheckBoxClassName} />
                  {tableHeader.map((item) => (
                    <TableHeadData key={item}>
                      {item}
                    </TableHeadData>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {listingsData?.map((item, index) => (
                  <TableRow
                    bordered={index + 1 < listingsData.length}
                    key={item?.listing_id}
                    dataRow={item?.listing_id}
                  >
                    <TableData>
                      <Checkbox
                        name={item?.listing_id}
                        onChange={() => onSelect(item?.listing_id)}
                        isActive={selectedId?.includes(item?.listing_id)}
                        disabled={!selectedId?.includes(item?.listing_id)
                        && selectedId?.length >= MAX_RELATED_ARTICLES_LISTING}
                      />
                    </TableData>
                    <TableData>
                      <ArticlesRelatedListingItem item={item} />
                    </TableData>
                    <TableData>
                      <div className="d-flex">
                        <Badge text={item?.ebay_status} type={ButtonTypes.SUCCESS} />
                      </div>
                    </TableData>
                    <TableData>
                      <div className="d-flex">
                        <Badge text={item?.listing_seller_manufacturer} type={ButtonTypes.LIGHT} />
                      </div>
                    </TableData>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        )}
        {!listingsLoading && listingsData?.length && currentPage !== lastPage
        && (
          <div>
            <br />
            <Button
              type={ButtonTypes.LIGHT}
              text="Get more"
              iconRight={<IconArrowDown />}
              onClick={onLoadMode}
            />
          </div>
        )}
        {listingsLoading && listingsData?.length && <DataLoader />}
      </div>
    </Modal>
  );
};

ArticlesRelatedListingsModal.propTypes = {
  setFieldValue: PropTypes.func,
  selectedListing: PropTypes.arrayOf(PropTypes.shape({})),
};

ArticlesRelatedListingsModal.defaultProps = {
  setFieldValue: () => {},
  selectedListing: []
};
export default ArticlesRelatedListingsModal;
